import AppMenu from 'components/templates/app-menu';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { isTrustedDevice } from '../../../../utils/mobile-devices';

export default function App({ children, device }) {
  const params = useParams();

  const { t } = useTranslation();

  const { pathname, search } = window.location;
  const { deviceId } = params;

  const DEVICE_DETAILS_URL = `/braincare/admin-mobile-devices/${deviceId}/info`;

  const HOME = t('organization.breadcrumbs.home');
  const MANAGE_DEVICES = t('organization.breadcrumbs.manage-devices');

  const DEVICE_INFO = t('organization.organization-mobile-devices-edit.title-sub-device-info');
  const DEVICE_DETAILS = t('organization.organization-mobile-devices-info.title-sub-info-device');

  const SIDE_MENU = isTrustedDevice(device.status)
    ? [
        {
          href: DEVICE_DETAILS_URL,
          text: DEVICE_INFO,
          isActive: pathname === DEVICE_DETAILS_URL,
        },
      ]
    : [
        {
          href: DEVICE_DETAILS_URL,
          text: DEVICE_INFO,
          isActive: pathname === DEVICE_DETAILS_URL,
        },
      ];

  const BREADCRUMBS = [
    {
      path: '/',
      title: HOME,
    },
    {
      path: '/braincare/admin-mobile-devices',
      title: MANAGE_DEVICES,
    },
    {
      path: `${pathname}${search}`,
      title: device.name ? device.name : DEVICE_DETAILS,
      isActive: true,
    },
  ];

  return (
    <AppMenu title={device.name ? device.name : DEVICE_DETAILS} breadcrumbs={BREADCRUMBS} menuItems={SIDE_MENU}>
      {children}
    </AppMenu>
  );
}
